<template>
  <div id="headtop">
    <div class="box">
      <header>
        <img class="bgImg" src="../assets/Assume-Image/组-3892.jpg" alt="" />
      </header>

      <div class="main">
        <div class="TopPosition">
          <img src="../assets/Assume-Image/蒙版组 118.png" alt="" />
        </div>
        <div class="pencil">
          <img src="../assets/Assume-Image/组 4108.png" alt="" />
        </div>
        <div class="topTitle">
          <div>
            <div class="topTitle-pos">
              <div>
                <div>
                  <p class="infoTitles">
                    河南省科学技术厅关于征集 “揭榜挂帅” 重大创新需求的通知
                  </p>
                  <span>
                    各省辖市、济源示范区、省直管县（市）、
                    “三起来”示范县（市）科技局，
                    各国家高新技术产业开发区管委会，郑州航空港综合经济实验区管委会，
                    省直有关部门，各有关单位：
                    <br />
                    　
                    　为深入贯彻习近平总书记的近期重要讲话精神和省委、省政府关于科技创新的决策部署，
                    努力打造国家创新高地，进一步改进完善项目组织管理机制，充分利用国内外优势创新资源，
                    省科技厅决定组织开展“揭榜挂帅”重大创新项目实施工作，公开征集“一流课题”和“一流成果”。
                    现将有关事项通知如下：
                    <br />
                    一、征集重点:
                  </span>
                  <br />
                  <router-link
                    target="_blank"
                    tag="a"
                    to="/LeftNotice"
                    class="toNewsMainInf"
                    >详情</router-link
                  >
                </div>
              </div>
              <img
                class="infoimg"
                src="../assets/Assume-Image/图层 5.png"
                alt=""
              />
            </div>
            <div class="inftop">
              <div>
                <p class="infoTitless">
                  河南省科学技术厅关于征集 “一流课题” 入库项目的通知
                </p>
                <span>
                  各省辖市、济源示范区、省直管县（市）、“三起来”示范县（市）科技主管部门，各国家高新区、郑州航空港综合经济实验区管委会，省直有关部门，各有关单位：
                  <br />
                  　　为深入贯彻习近平总书记近期重要讲话精神和省委、省政府关于科技创新的决策部署，围绕国家重大战略需求、河南转型发展需要，在原创性、基础性、应用性领域梳理凝炼一流课题，引育一流团队人才，打好关键核心技术攻坚战，努力打造国家创新高地，省科技厅决定面向全省征集重大科技创新项目库入库项目。现将有关事项通知如下：
                  <br />
                  一、征集对象:
                </span>
                <router-link
                  target="_blank"
                  tag="a"
                  to="/RightNotice"
                  class="toNewsMainInf"
                  >详情</router-link
                >
              </div>
              <img
                class="infoimg"
                src="../assets/Assume-Image/图层 5.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="newsInf">
          <div class="newContainer">
            <div class="newIntroduce">
              <p class="infoTitle">相关通知</p>
              <br />
              <span>NEWS AND INFORMATION</span>
              <div class="newsdv" @click="more">
                更多
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="newList" v-if="newsList.length > 0">
              <div class="layui-carousel leftImg" id="test1">
                <div carousel-item>
                  <el-carousel
                    trigger="click"
                    style="height: 18.4375"
                    arrow="always"
                  >
                    <el-carousel-item v-for="item in imag" :key="item.ID">
                      <div style="position: relative" @click="news(item.ID)">
                        <div class="texta">{{ item.Titile }}</div>
                        <img :src="item.Picture" alt="" />
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>

              <ul>
                <li
                  class="news"
                  v-for="item in newsList"
                  :key="item.ID"
                  @click="news(item.ID)"
                >
                  <span>{{ item.Titile }}</span>
                  <span>{{ item.CreateTime.substring(0, 10) }}</span>
                </li>
              </ul>
            </div>
            <div v-else class="nexttemp">
              <empty />
            </div>
          </div>
        </div>
        <div class="policy">
          <div class="policyInf">
            <img src="../assets/Assume-Image/Oval.png" alt="" />
            <p class="infoTitle">支持政策</p>
            <br />
            <span class="infospan">SUPPORTIVE POLICES</span>
            <br />
            <span class="policyText">
              &nbsp; &nbsp; &nbsp; &nbsp; 省科技厅将组织专家对项目需求进行筛选,
              重点遴选出创新性强、影响力大、带动作用强、应用面广的关键核心技术研发需求，
              以及重大创新成果转化需求，面向全社会公开张榜。揭榜方按张榜项目要求，
              主动与发榜方对接，细化落实合作具体内容，签订技术合同，或双方达成共识，
              制定发榜项目的可行性方案。省科技厅组织专家对揭榜方的资质条件、揭榜方案可行性、发榜方满意度等进行论证，
              确定中榜项目名单并发布成功揭榜公告。成功揭榜的项目将纳入省级科技计划项目进行管理。
              <br />
              <br />
              &nbsp; &nbsp;&nbsp;
              &nbsp;“揭榜挂帅”项目按照不低于项目合同总额的20%核定省财政资金支持经费，
              上不封顶。经费分批次拨付，项目立项后按照支持经费的一定比例拨付首批经费；
              根据项目实施进展的重要节点，分期拨付后续经费。</span
            >
          </div>
          <div>
            <img src="../assets/Assume-Image/图层 3.png" alt="" />
          </div>
        </div>

        <div class="redhead">
          <div class="redTitle">
            <img src="../assets/Assume-Image/组 3866.png" alt="" />
            <div>
              “揭榜挂帅”张榜项目 &nbsp;&nbsp;
              <br />
              <span class="redspan"
                >第二届中国·河南河南开放创新暨跨过技术转移大会</span
              >
            </div>
          </div>
          <div class="relevant">
            <div class="head">
              <div class="head">
                <button
                  v-for="(i, n) in itemBtn"
                  :key="n"
                  @click="changeType(n)"
                  :class="inde === n ? 'focusBtnStyle' : ''"
                  class="layui-btn layui-btn-primary"
                >
                  {{ i.name }}
                </button>
              </div>
            </div>
            <div class="show">
              <ul>
                <li
                  v-for="(item, index) in zhangbanglist"
                  :key="index"
                  class="shite"
                  @click="zhangLis(item.ID)"
                >
                  <img
                    class="showimg"
                    v-if="item.IsTechnical === 0"
                    src="../assets/Assume-Image/组 4205.png"
                    alt=""
                  />
                  <img
                    class="showimg"
                    v-else
                    src="../assets/Assume-Image/组 4206.png"
                    alt=""
                  />
                  <h3 class="project_title" :class="'contents' + index">
                    {{ item.Title }}
                  </h3>
                  <template v-if="item.IsTechnical == 0">
                    <div class="itemDesc">
                      {{ item.DemandDescription }}
                    </div>
                    <div class="project_mes">
                      <div class="projdiv">
                        —— 单位名称：{{ item.CompanyOrPersonName }}
                      </div>
                    </div>
                  </template>

                  <template v-else>
                    <div class="itemDesc">
                      {{ item.ResultsInformation }}
                    </div>
                    <div class="project_mes">
                      <div></div>
                      <div class="project_mes-dv">
                        —— 单位名称：{{ item.CompanyOrPersonName }}
                      </div>
                    </div>
                  </template>
                </li>
              </ul>
            </div>
            <div class="lookMore">
              <router-link
                class="layui-btn layui-btn-radius LookMoreBtn layui-btn-primary"
                tag="a"
                to="/moreZbitems"
                >查看更多项目</router-link
              >
            </div>
          </div>
        </div>
        <div class="redtop">
          <div class="redTitle">
            <img src="../assets/Assume-Image/组 3866.png" alt="" />
            <div>
              “揭榜挂帅”签约项目 &nbsp;&nbsp;
              <br />
              <span class="redspan">
                第二届中国·河南河南开放创新暨跨过技术转移大会
              </span>
            </div>
          </div>
          <div class="ChangeOneTwo">
            <span
              @click="ChangeYear(1)"
              :class="OneOrTow == 1 ? 'OneOrTow' : ''"
              >第二届大会</span
            >
            <span
              @click="ChangeYear(2)"
              :class="OneOrTow == 2 ? 'OneOrTow' : ''"
              >第一届大会</span
            >
          </div>
          <div class="relevant">
            <div class="head" v-show="OneOrTow == 1">
              <button
                v-for="(i, n) in itemBtn"
                :key="n"
                @click="changeType(n)"
                :class="inde === n ? 'focusBtnStyle' : ''"
                class="layui-btn layui-btn-primary"
              >
                {{ i.name }}
              </button>
            </div>
            <!-- 第二届 -->
            <div class="show">
              <ul>
                <li
                  v-for="(item, index) in qianyuelist"
                  :key="index"
                  class="show-li"
                >
                  <img
                    v-if="item.IsTechnical === 0 && OneOrTow == 1"
                    src="../assets/Assume-Image/组 4205.png"
                    alt=""
                  />
                  <img
                    v-if="item.IsTechnical != 0 && OneOrTow == 1"
                    src="../assets/Assume-Image/组 4206.png"
                    alt=""
                  />
                  <img
                    v-if="OneOrTow != 1"
                    src="../assets/Assume-Image/组 4419@2x.png"
                    alt=""
                  />
                  <div class="showone">
                    <h3 class="project_title" :class="'contentss' + index">
                      {{ item.Title }}
                    </h3>
                    <div class="qianyue">签约双方</div>
                    <div class="party">
                      {{ item.PartyA }}
                    </div>

                    <div class="PartyB">
                      {{ item.PartyB }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="lookMore">
              <router-link
                class="layui-btn layui-btn-radius LookMoreBtn layui-btn-primary"
                tag="a"
                to="/moreQyItems"
                >查看更多项目</router-link
              >
            </div>
          </div>
        </div>

        <div class="bottomPosition">
          <img src="../assets/Assume-Image/whiteFFF.png" alt="" />
        </div>
        <div class="redBottom">
          <img src="../assets/Assume-Image/蒙版组 120.png" alt="" />
        </div>
      </div>
    </div>
    <div class="back"></div>
  </div>
</template>
<script>
import empty from "@/components/empty.vue";
import { getAction, postAction } from "@/api/api";
import qs from "qs";
import { ZhangBangList } from "@/api/url";
export default {
  data() {
    return {
      newsList: [],
      itemBtn: [
        {
          name: "全部",
        },
        {
          name: "技术攻关类",
        },
        {
          name: "成果转化类",
        },
      ],
      inde: 0,
      zhangbanglist: [],
      zhang: null,
      qianyuelist: [],
      OneOrTow: 1,
      qiang: null,
      imag: [],
    };
  },
  created() {
    this.$bus.$emit("isSpecial", "Assume");
    this.loadNewsList();
    this.zhangBangList();
    this.qianYue();
  },
  components: {
    empty,
  },
  methods: {
    //新闻更多
    more() {
      let routeData = this.$router.resolve({
        path: "/AboutInform",
        query: { type: 4 },
      });
      window.open(routeData.href, "_blank");
    },
    //详情跳转
    news(id) {
      let routeData = this.$router.resolve({
        path: "/NewsInfo",
        query: {
          id: id,
          type: 4,
        },
      });
      window.open(routeData.href, "_blank");
    },
    changeType(n) {
      this.inde = n;
      if (n <= 0) {
        this.zhang = null;
      } else {
        this.zhang = n - 1;
      }
      let data = {
        action: "Get_ZhangBangList",
        sort: "ID ASC",
        IsSigned: 1,
        pageSize: 9,
        page: 1,
        IsTech: this.zhang,
      };
      getAction(ZhangBangList, data).then((res) => {
        this.zhangbanglist = res.data;
      });

      this.qiang = n;
      if (this.qiang <= 0) {
        this.qiang = null;
      } else {
        this.qiang = n - 1;
      }

      let datad = {
        action: "Get_ZhangBangProjQyList",
        sort: "ID DESC",
        InptuSys: 1,
        pageSize: 9,
        page: 1,
        IsTechnical: this.qiang,
        Year: 2021,
      };
      getAction(ZhangBangList, datad).then((res) => {
        this.qianyuelist = res.data;
      });
    },
    loadNewsList() {
      let data = {
        action: "Get_ZhangBangInformationList",
        Type: 3,
        Count: 5,
      };
      getAction(ZhangBangList, data).then((res) => {
        this.newsList = res;

        this.newsList.forEach((item) => {
          if (item.Picture !== "") {
            this.imag.push(item);
          }
        });
      });
    },
    zhangBangList() {
      let data = {
        action: "Get_ZhangBangList",
        sort: "ID ASC",
        IsSigned: 1,
        pageSize: 9,
        page: 1,
      };
      getAction(ZhangBangList, data).then((res) => {
        this.zhangbanglist = res.data;
      });
    },
    qianYue() {
      let data = {
        action: "Get_ZhangBangProjQyList",
        sort: "ID DESC",
        InptuSys: 1,
        pageSize: 9,
        page: 1,
        Year: 2021,
      };
      getAction(ZhangBangList, data).then((res) => {
        this.qianyuelist = res.data;
      });
    },
    //签约项目
    ChangeYear(n) {
      this.OneOrTow = n;
      if (n == 2) {
        let data = {
          action: "Get_ZhangBangProjQyList",
          sort: "ID DESC",
          InptuSys: 1,
          pageSize: 9,
          page: 1,
          Year: 2019,
        };
        getAction(ZhangBangList, data).then((res) => {
          this.qianyuelist = res.data;
        });
      } else {
        this.qianYue();
      }
    },
    //张榜跳转
    zhangLis(item) {
      let routeData = this.$router.resolve({
        path: "/ZbData",
        query: {
          list: item,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style src="../assets/Ass-css/guashui.css"  scoped></style>
<style  lang='css' scoped>
#headtop {
  position: relative;
}
.box {
  position: relative;
  background: #fff9ee;
}
img {
  width: 100%;
  height: 100%;
}
.main {
  width: 76.25rem;
}
.topTitle-pos {
  position: relative;
}
::v-deep .texta {
  width: 100%;
  height: 5rem;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.56);
  text-align: center;
  color: #fff;
  line-height: 3.625rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.container {
  width: 80rem;
  text-align: center;
  background: #fff;
  padding-bottom: 3.125rem;
}
::v-deep .el-carousel__button {
  width: 0.625rem !important;
  height: 0.625rem !important;
  border: none;
  border-radius: 50% !important;
}
.show li {
  width: 22.5rem !important;
}
.show li:hover h3 {
  color: #308bec;
}
.infoimg {
  position: absolute;
  width: 21.875rem;
  right: -0.3125rem;
  height: auto;
  bottom: -1.875rem;
}
.newsdv {
  float: right;
  font-size: 0.875rem;
  cursor: pointer;
}
.nexttemp {
  text-align: center;
  display: block;
  margin: 0 auto;
}
.nextp {
  margin-left: -5rem;
  margin-top: 1.25rem;
  color: #cccccc;
}
.policyInf img {
  position: absolute;
  width: 50%;
  height: auto;
}
.infospan {
  color: #999;
}
.redhead {
  overflow: hidden;
}
.project_mes {
  z-index: 99;
  padding: 0 0.9rem !important;
}
.project_mes-dv {
  margin-right: 1.875rem;
  line-height: 1.7rem;
}
.show-li {
  overflow: hidden;
  height: 17rem !important;
  cursor: default;
  width: 26rem;
  cursor: pointer;
}
.show-li img {
  height: 5.625rem;
}
.qianyue {
  height: 2rem;
  font-size: 1rem;
  color: #737373;
  text-align: center;
  margin-top: -0.9375rem;
  font-weight: bold;
}
.party {
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 2rem;
  font-size: 1rem;
  color: #999;
  padding: 0 1rem;
  text-align: center;
}
.PartyB {
  margin-top: 0;
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1rem;
  color: #999;
  padding: 0 1rem;
  height: 2rem;
  text-align: center;
}
.redtop {
  overflow: hidden;
}
.inftop {
  position: relative;
}
.redspan {
  font-size: 0.875rem;
}
.showimg {
  height: 5.625rem;
}
.projdiv {
  margin-right: 1.875rem;
  line-height: 1.5rem;
}
.showone {
  height: 9.125rem;
}
.showone h3 {
  text-align: center;
}
.itemDesc {
  height: 5.2rem !important;
  margin: 0.9rem;
  margin-top: 0;
}
.redBottom {
  left: 0.025rem !important;
}
.show ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.relevant ul li h3 {
  z-index: 99;
  padding: 0.9375rem !important;
  height: 4rem !important;
  font-size: 1.125rem !important;
}
.shite {
  z-index: 99;
  height: 21rem !important;
  cursor: pointer;
}
.back {
  width: 100%;
  height: 10rem;
  background: #fff9ee;
  position: absolute;
  bottom: -9.3rem;
  left: 0;
  z-index: -9;
}
</style>